import React, { useState } from 'react';
import { SearchOutlined } from '@ant-design/icons';
import { SearchModalMobile } from '../SearchModalMobile';
export function SearchMobile({ environment }) {
    const [isDrawerVisible, setIsDrawerVisible] = useState(false);
    const showDrawer = () => {
        setIsDrawerVisible(true);
    };
    const onClose = () => {
        setIsDrawerVisible(false);
    };
    return (React.createElement("div", { className: "relative mt-4 w-[272px] h-10 flex rounded-md" },
        React.createElement("input", { id: "inputSearchPackage", type: "text", placeholder: "Buscar pacotes", className: "w-[90%] placeholder:text-black bg-white shadow-xl placeholder:font-semibold focus:outline-none focus:border-orange-500 rounded-l-xl p-6", onClick: showDrawer }),
        React.createElement("div", { className: "bg-orange-600 w-[20%] rounded-r-xl justify-center items-center flex" },
            React.createElement(SearchOutlined, { className: "text-black" })),
        React.createElement(SearchModalMobile, { isDrawerVisible: isDrawerVisible, onClose: onClose, environment: environment })));
}
;
//# sourceMappingURL=index.js.map